// extracted by mini-css-extract-plugin
module.exports = {"component":"PopoverNone_component__1um6S","inner":"PopoverNone_inner__2yFY5","footer":"PopoverNone_footer__3nQci"};